(function () {
  const config = window.DLE_AI_ASSISTANT || {};
  const endpoint = String(config.endpoint || '').replace(/\/$/, '');
  const root = document.getElementById('dle-ai-assistant-root');
  if (!root || !endpoint || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const greetings = [
    'Ask me for exact product links, prices, categories, or help choosing a guide.',
    'Need a real product recommendation from this store? Tell me your goal.',
    'I can help with product details, prices, blog posts, policies, and links.',
    'Looking for a digital guide? Ask me and I will use the store catalog.'
  ];

  const visitorId = getVisitorId();
  const assistantAvatarUrl = escapeAttribute(String(config.avatarUrl || ''));
  let busy = false;

  root.innerHTML = `
    <div class="dle-ai-assistant">
      <button class="dle-ai-assistant__toggle" type="button" aria-expanded="false" aria-controls="DleAiAssistantPanel" aria-label="Open Digital Lab assistant">
        <img class="dle-ai-assistant__toggle-avatar" src="${assistantAvatarUrl}" alt="" loading="lazy">
        <span>Ask assistant</span>
      </button>
      <section id="DleAiAssistantPanel" class="dle-ai-assistant__panel" aria-label="Digital Lab assistant chat" hidden>
        <div class="dle-ai-assistant__header">
          <div class="dle-ai-assistant__title">
            <strong>Digital Lab Assistant</strong>
          </div>
          <button class="dle-ai-assistant__close" type="button" aria-label="Close assistant">${iconClose()}</button>
        </div>
        <div class="dle-ai-assistant__messages" role="log" aria-live="polite" aria-relevant="additions"></div>
        <div class="dle-ai-assistant__status" aria-live="polite"></div>
        <form class="dle-ai-assistant__form">
          <textarea class="dle-ai-assistant__input" rows="1" maxlength="1200" placeholder="Ask about products, prices, links..."></textarea>
          <button class="dle-ai-assistant__send" type="submit" aria-label="Send message">${iconSend()}</button>
        </form>
      </section>
    </div>
  `;

  const toggle = root.querySelector('.dle-ai-assistant__toggle');
  const panel = root.querySelector('.dle-ai-assistant__panel');
  const close = root.querySelector('.dle-ai-assistant__close');
  const messages = root.querySelector('.dle-ai-assistant__messages');
  const status = root.querySelector('.dle-ai-assistant__status');
  const form = root.querySelector('.dle-ai-assistant__form');
  const input = root.querySelector('.dle-ai-assistant__input');
  const send = root.querySelector('.dle-ai-assistant__send');

  toggle.addEventListener('click', function () {
    const open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close Digital Lab assistant' : 'Open Digital Lab assistant');
    if (open) {
      ensureInitialHistory();
      window.setTimeout(() => input.focus({ preventScroll: true }), 50);
    }
  });

  close.addEventListener('click', function () {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus({ preventScroll: true });
  });

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy) return;
    const text = input.value.trim();
    if (!text) return;
    input.value = '';
    addMessage('user', text);
    await sendMessage(text);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });

  async function ensureInitialHistory() {
    if (messages.dataset.loaded === 'true') return;
    messages.dataset.loaded = 'true';
    setStatus('Loading your assistant history...');
    try {
      const response = await fetch(`${endpoint}/history?visitorId=${encodeURIComponent(visitorId)}`, {
        headers: { 'Accept': 'application/json' }
      });
      const data = await response.json();
      if (data.ok && Array.isArray(data.messages) && data.messages.length) {
        data.messages.slice(-30).forEach(item => addMessage(item.role, item.content));
        setStatus('History loaded.');
      } else {
        addMessage('assistant', greetings[Math.floor(Math.random() * greetings.length)]);
        setStatus('Ready.');
      }
    } catch (error) {
      addMessage('assistant', greetings[Math.floor(Math.random() * greetings.length)]);
      setStatus('Ready.');
    }
  }

  async function sendMessage(text) {
    setBusy(true);
    setStatus('Checking the store catalog...');
    try {
      const response = await fetch(`${endpoint}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          visitorId,
          message: text,
          pageUrl: window.location.href,
          pageTitle: document.title
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) {
        throw new Error(data.error || 'The assistant could not answer right now.');
      }
      addMessage('assistant', data.reply);
      setStatus(`Answered from ${data.productCount || 0} store products.`);
    } catch (error) {
      addMessage('assistant', 'I could not reach the assistant service right now. Please try again in a moment, or use the Contact page for support.');
      setStatus(error.message || 'Assistant unavailable.');
    } finally {
      setBusy(false);
    }
  }

  function addMessage(role, text) {
    let item;
    if (role === 'user') {
      item = document.createElement('div');
      item.className = 'dle-ai-assistant__message dle-ai-assistant__message--user';
      item.innerHTML = renderMessage(text);
    } else {
      item = document.createElement('div');
      item.className = 'dle-ai-assistant__assistant-row';
      item.innerHTML = `
        <img class="dle-ai-assistant__avatar" src="${assistantAvatarUrl}" alt="Digital Lab support assistant" loading="lazy">
        <div class="dle-ai-assistant__message dle-ai-assistant__message--assistant">${renderMessage(text)}</div>
      `;
    }
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
  }

  function setBusy(next) {
    busy = next;
    input.disabled = next;
    send.disabled = next;
  }

  function setStatus(text) {
    status.textContent = text || '';
  }

  function renderMessage(text) {
    const escaped = escapeHtml(String(text || ''));
    const markdownBold = escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    const markdownLinked = markdownBold.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, function (_, label, url) {
      return `<a href="${escapeAttribute(url)}" target="_blank" rel="noopener noreferrer">${label}</a>`;
    });
    return markdownLinked.replace(/(^|[\s(])(https:\/\/digitallabempire\.com\/[^\s<)]+)/g, function (_, prefix, url) {
      return `${prefix}<a href="${escapeAttribute(url)}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }

  function getVisitorId() {
    const key = 'dle_ai_visitor_id';
    let id = localStorage.getItem(key) || readCookie(key);
    if (!id || !/^[a-zA-Z0-9_-]{16,96}$/.test(id)) {
      id = `dle_${crypto.randomUUID().replace(/-/g, '')}`;
    }
    localStorage.setItem(key, id);
    document.cookie = `${key}=${id}; Max-Age=31536000; Path=/; SameSite=Lax; Secure`;
    return id;
  }

  function readCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function escapeHtml(value) {
    return value.replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function escapeAttribute(value) {
    try {
      if (!value) return '#';
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '#';
      return escapeHtml(url.toString());
    } catch {
      return '#';
    }
  }

  function iconClose() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  }

  function iconSend() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>';
  }
})();
